<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'close-period',
};
</script>
